import { render, staticRenderFns } from "./SubmenuIcon.vue?vue&type=template&id=04a6b88f&"
import script from "./SubmenuIcon.vue?vue&type=script&lang=js&"
export * from "./SubmenuIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports